import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from "@material-ui/core/Grid";
import AlertMessage from "./AlertMessage";
import {decodeEntities, getMonth} from "../utils/functions";
import {Typography} from "@material-ui/core";
import Select from "./Select";
import Pagination from "@material-ui/lab/Pagination";

const useStyles = makeStyles({
    root:{
        "&:nth-child(even)": {
            backgroundColor: 'f7f9fa',
        },
    },
    table: {
        width: '100%'
    },
    row: {
        paddingTop: '2%',
        paddingBottom:'2%',

    },
    link: {
        fontWeight: 'bold',
        "&:hover": {
            color: "green",
            cursor: 'pointer'
        },
    }
});




export default function News(props) {
    const classes = useStyles();

    const [page, setPage] = React.useState(1);
    const [rowPerPage, setRowPerPage] = React.useState(10)

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowPerPage(parseInt(event, 10))
        setPage(1);
    };

    let items = props.items.slice((page - 1) * rowPerPage, (page - 1) * rowPerPage + rowPerPage).map((elem) => {
        let date = new Date(elem.publish_date);
        let preview = decodeEntities(elem.body)
        if (preview.length > 300) {
            preview = preview.slice(0, 300) + '.....<br />...................'
        }
        return (<Grid container className={classes.row}>
            <Grid component={'div'}xs={1} sm={1} xl={1} style={{
                textAlign: 'center',
                color: "gray",
            }}>
                <div style={{fontSize: '0.9rem',}}>{getMonth(date)}</div>
                <div style={{fontSize: '2rem',}}>{date.getDate()}</div>
                <div style={{fontSize: '0.9rem',}}>{date.getFullYear()}</div>
            </Grid>
            <Grid component={'div'}xs={11} sm={11} xl={11} >
                <AlertMessage
                    title={date.getDate() + ' ' + getMonth(date) + ' ' + date.getFullYear()}
                    content={elem.body}
                >
                    <div className={classes.link}> {elem.title}</div>
                    <div dangerouslySetInnerHTML={{__html: preview}} />
                </AlertMessage>


            </Grid>
        </Grid>)
    })
    return (
        <Paper>
            <Grid container className={classes.root}>
                {items}
            </Grid>
            <Grid container>
                <Grid item xs={7} sm={7} md={7} lg={7}></Grid>
                <Grid item xs={5} sm={5} md={5} lg={5} style={{
                    display: 'flex',
                    aligItems: 'center',
                    fontSize: '11px',
                    alignItems: 'center',
                    color: 'gray'
                }}>
                    <Typography variant={'span'} style={{'marginRight': '10px'}}>
                        Записей на странице
                    </Typography>
                    <Select
                        type={'select'}
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        borderRadius={'20px 20px'}
                        width={'76px'}
                        onChange={handleChangeRowsPerPage}
                    />

                    <Pagination
                        classes={{selected: classes.selectedPagin}}
                        count={Math.ceil(props.items.length / rowPerPage)}
                        color="primary"
                        page={page}
                        onChange={handleChangePage}
                        size={'large'}/>
                </Grid>
            </Grid>
        </Paper>
    );

}